<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div class="search-check-group-body flex flex-wrap items-center gap-x-8 gap-y-0 flex-1">
        <vs-checkbox v-for="(item, index) in list"
                     class="m-0"
                     color="secondary"
                     :vs-value="item.value"
                     :checked="checkList.indexOf(item.value) !== -1"
                     @change="onChangeCheck">{{ item.text || item.value }}</vs-checkbox>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="labelHidden" :columns="options['gridTemplateColumns']">
      <div class="search-check-group-body grid sm:flex flex-wrap items-center gap-x-8 gap-y-0 flex-1">
        <vs-checkbox v-for="(item, index) in list"
                     class="m-0"
                     color="secondary"
                     :vs-value="item.value"
                     :checked="checkList.indexOf(item.value) !== -1"
                     @change="onChangeCheck">{{ item.text || item.value }}</vs-checkbox>
      </div>
    </search-label-body>
  </div>
</template>
<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchCheckGroup",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  props: {
    label: String,
    value: Array,
    setRef: Function,
    query: {
      type: Object,
      default: () => {
        return {
          'ck_l': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.checkList = value;
    },

  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultCheckList = this.options && this.options['default'] ? this.options['default'] : "";
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const checkList = query[_query_keys[0]];
      if (checkList) {
        try {
          return {
            checkList: typeof checkList === 'string' ? [checkList] : checkList,
          };
        } catch (e) {}
      }
      return {
        checkList: defaultCheckList,
      };
    },
    list() {
      return this.options.list || [];
    },
    selectMaxCount() {
      return this.options ? this.options.selectMaxCount : 1;
    },
    labelHidden () {
      return !(this.isMobile || this.label);
    }
  },
  data() {
    return {
      checkList: this.value || [],
    };
  },
  created() {
    const list = this.initData.checkList
    for (let i = 0; i<list.length; i++) {
      this.onChangeCheck(list[i], true)
    }
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
    // CheckBox 를 선택 후 다시 해제하여 검색하면, 검색이 되지 않는 문제가 있어서 추가함.
    this.$emit("input", this.checkList);
  },
  methods: {
    onChangeCheck(value, fixedValue) {
      const index = this.checkList.indexOf(value);
      if (index === -1) {
        this.checkList.push(value);
      } else {
        if (!fixedValue) {
          this.checkList.splice(index, 1);
        }
      }

      if (this.selectMaxCount > 0 && this.checkList.length > this.selectMaxCount) {
        this.checkList.shift();
      }

      this.$emit("input", this.checkList);
    },
    onClickFilterRemove () {
      this.checkList = [];
      this.$emit("input", this.checkList);
    }
  }
}
</script>
<style lang="scss" scoped>
.search-check-group-body {
  line-height: 38px;
}
</style>
